import Vue from 'vue';
import VueAxios from 'vue-axios';
import axios from 'axios';

Vue.use(VueAxios, axios)

// bootstrap (Please don't move)
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import App from './App';
import router from './router';
import store from './store'; // vuex store

// global constants
import globalConstants from '@/utils/global-constants.js';
Object.defineProperty(Vue.prototype, '$globalConstants', { value: globalConstants }); // read-only

// app notifications
import Notifications from 'vue-notification';
Vue.use(Notifications);

// 3rd party plugins
import VueAnalytics from 'vue-analytics';
Vue.use(VueAnalytics, {
  id: 'UA-136697074-1',
  checkDuplicatedScript: true,
  router,
});

// clipboard
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

// lazy load components
import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload);

// XSS Protection
String.prototype.applyXSSprotection = function () {
  return this.replace(/</g, '&lt;').replace(/>/g, '&gt;');
};

// Intro.js
import introJs from './components/introjs/intro.js';
Object.defineProperty(Vue.prototype, '$introJs', { value: introJs });

// carousel
import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);

// highlight.js
import VueHighlightJS from 'vue-highlight.js';
import javascript from 'highlight.js/lib/languages/javascript';
import 'highlight.js/styles/darcula.css';
Vue.use(VueHighlightJS, {
  languages: {
    javascript,
  },
});

// vue-icon
import feather from 'vue-icon';
Vue.use(feather, 'v-icon');

// vue-modal
import VModal from 'vue-js-modal';
Vue.use(VModal);

Vue.config.productionTip = false;

// vue global mixins
Vue.mixin({
  methods: {
    capitalizeFirstLetter: str => str.charAt(0).toUpperCase() + str.slice(1),
    removeCharactarInString(chr, str) {
      const pos = str.indexOf(chr);
      return str.substring(0, pos) + str.substring(pos + 1);
    },
    str_to_snake_case: (str) => str.toLowerCase().split(' ').join('_'),
    snake_to_pascal_case: (str) => str.split('_').map(s => s[0].toUpperCase() + s.slice(1, s.length)).join(' '),
    setWindowLocalStorage(key, value) {
      localStorage.setItem(key, value);
    },
    getWindowLocalStorage(key) {
      return localStorage.getItem(key);
    },
    checkEmailFormat(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email));
    },
    insertCommaInNumber(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    formatPhoneNumber(phoneNumberString) {
      const cleaned = ('' + phoneNumberString).replace(/\D/g, '')
      const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
      if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3]
      }
      return null
    },
    isPhone(phone) {
      // normalize string and remove all unnecessary characters
      phone = phone.replace(/\D+/g, '');
      return phone.length === 10 || phone.length === 11;
    },
    replaceURLWithHTMLLinks(text) {
      let exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
      let text1 = text.replace(exp, "<a href='$1' target='_blank' style='color:white' >$1</a>");
      let exp2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
      return text1.replace(exp2, '$1<a target="_blank" href="http://$2">$2</a>');
    },
    getMonthName(idx) {
      idx = idx || new Date().getMonth();
      const month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return month[idx];
    },
    transformUnderscoreToSpace(string) {
      return string.replace(/_+/g, ' ')
    },
    exportToCsv(filename, rows) {
      // var processRow = function(row) {
      //   var finalVal = "";
      //   for (var j = 0; j < row.length; j++) {
      //     var innerValue = row[j] ? row[j].toString() : "-";
      //     if (row[j] instanceof Date) {
      //       innerValue = row[j].toLocaleString();
      //     }
      //     var result = innerValue.replace(/"/g, '""');
      //     if (result.search(/("|,|\n)/g) >= 0) result = '"' + result + '"';
      //     var re = new RegExp("\n", "g");
      //     innerValue = innerValue.replace(re, "");
      //     if (j > 0) finalVal += ",";
      //     finalVal += result;
      //   }
      //   return finalVal + "\n";
      // };
      // var csvFile = "";
      // for (var i = 0; i < rows.length; i++) {
      //   csvFile += processRow(rows[i]);
      // }
      var blob = new Blob([rows], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    }
  }
});

// vue global filters
Vue.filter('shorten', function (msg, len) {
  if (!msg) return '';
  return msg.length > len ? msg.substr(0, len) + '...' : msg;
});

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',

  methods: {
    authenticate: function (provider) {
      this.$auth.authenticate(provider).then(function () {
        //Execute application logic after successful social authentication
      })
    }
  }

});



// WEBPACK FOOTER //
// ./src/main.js